/* BHB: animatii de intrare la scroll.
   Adauga .bhb-reveal pe tintele de mai jos si .is-in cand intra in viewport,
   cu esalonare (--bhb-reveal-i) pe fratii din acelasi rand. Progresiv:
   fara IntersectionObserver sau la prefers-reduced-motion nu se atinge nimic
   (CSS-ul tine continutul vizibil in lipsa clasei .bhb-reveal). */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var TARGETS = [
    '.bhb-fam-cover',
    '.sec__collection-list .collection-item',
    '.bhbr-item',
    '.section__header',
    '.bhb-hero__content > *'
  ];
  /* BHB: NU include selectoare din interiorul unui carusel Swiper (mobil):
     ".sec__collection-tab .product-item" ("Produse recomandate") si
     ".sec__icon-box .sec__icon-box-item" (bara de beneficii, carousel_on_mobile).
     Swiper isi reconstruieste nodurile la initializare; elementele ramaneau
     legate de un IntersectionObserver pe noduri "moarte" si nu ajungeau
     niciodata la .is-in - opacity:0 permanent (produse invizibile / bara de
     beneficii aparea o fractiune de secunda apoi disparea). Pe desktop nu
     exista caruselul, de-aia parea OK acolo. */

  var els = document.querySelectorAll(TARGETS.join(','));
  if (!els.length) return;

  // esalonare pe frati: elementele cu acelasi parinte intra unul dupa altul
  var byParent = new Map();
  els.forEach(function (el) {
    var p = el.parentElement;
    var i = byParent.get(p) || 0;
    el.style.setProperty('--bhb-reveal-i', Math.min(i, 8));
    byParent.set(p, i + 1);
    el.classList.add('bhb-reveal');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  els.forEach(function (el) {
    // ce e deja pe ecran la incarcare intra imediat, fara "pop" intarziat
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      el.classList.add('bhb-reveal');
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    } else {
      io.observe(el);
    }
  });
})();
